import IncidentsCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['number_of_incidents', 'shipper_orders_skin'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { number_of_incidents: numberOfIncidents, shipper_orders_skin } =
      props.selectors.getJourneyFields(state, props.journeyId, fields);
    return {
      numberOfIncidents,
      shipper_orders_skin,
      journeyId: props.journeyId,
    };
  })
);

export default enhance(IncidentsCell);
